<template>
  <div class="circle" :class="[theme, size]">
    <span class="initials">{{ userInitials() }}</span>
  </div>
</template>

<script>
export default {
  props: {
    firstname: {
      type: String,
      default: ''
    },
    lastname: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: ''
    }
  },

  methods:  {
    userInitials () {
      if (this.firstname && this.lastname) {
        return this.firstname.charAt(0) + this.lastname.charAt(0)
      } else if (this.firstname) {
        return this.firstname.charAt(0)
      } else if (this.lastname) {
        return this.lastname.charAt(0)
      } else if (this.email) {
        return this.email.charAt(0)
      } else {
        return '?'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.circle
  background-color: $paper
  border-radius: 50%
  height: 32px
  text-align: center
  width: 32px
  display: inline-block
  margin-top: 4px
  .initials
    font-size: 16px /* 50% of parent */
    font-weight: $font-medium
    color: $sensual
    line-height: 34px
    vertical-align: middle
    position: relative
    font-family: $font-family
    text-transform: uppercase

  // Sizes
  &.medium
    height: 64px
    width: 64px
    min-height: 64px
    min-width: 64px
    .initials
      line-height: 63px
      font-size: 32px
      font-weight: $font-semi-bold
  &.small
    min-width: 32px
    min-height: 32px

  // Themes
  &.unclassified
    background-color: $paper
    .initials
      color: $ink
  &.default
    background-color: $paper
    .initials
      color: $ink
  &.sensual
    background-color: $ink
    .initials
      color: $sensual
  &.sensual-lighter
    background-color: $sensual-lighter
    .initials
      color: $sensual
  &.cold
    background-color: $lead-cold-light
    .initials
      color: $lead-cold-dark
  &.warm
    background-color: $yellow-lighter
    .initials
      color: $yellow-dark
  &.hot
    background-color: $red-lighter
    .initials
      color: $red-dark
</style>



// WEBPACK FOOTER //
// UserImage.vue?08dd7dda